// extracted by mini-css-extract-plugin
export default {"step":"step_step__L0gPD","counter":"step_counter__ayOl6","description":"step_description__yk-Xn","icon":"step_icon__uLnW3"};